<template>
  <div class="footer margin-general">
    <div class="grid-container-links">
      <div class="grid-item">
        <NuxtLink :to="localPath('/trading/markets')" class="title-item body-3-bold" style="text-decoration: none">
          <p class="title-item body-3-bold">{{ $t(markets.title) }}</p>
        </NuxtLink>
        <ul>
          <li v-for="(item, index) in markets.subHyperlinks" :key="index">
            <NuxtLink v-if="item.path" :to="localPath(item.path)" class="caption-1">
              {{ $t(item.name) }}
            </NuxtLink>
          </li>
        </ul>
      </div>
      <div class="grid-item">
          <p class="title-item body-3-bold">{{ $t(platforms.title) }}</p>
        <ul>
          <li v-for="(item, index) in platforms.subHyperlinks" :key="index">
            <NuxtLink v-if="item.path" :to="localPath(item.path)" class="caption-1">
              {{ $t(item.name) }}
            </NuxtLink>
          </li>
        </ul>
      </div>
      <div class="grid-item">
       <p class="title-item body-3-bold">{{ $t(yourTrading.title) }}</p>
        <ul>
          <li v-for="(item, index) in yourTrading.subHyperlinks" :key="index">
            <NuxtLink v-if="item.path" :to="localPath(item.path)" class="caption-1">
              {{ $t(item.name) }}
            </NuxtLink>
          </li>
        </ul> 
      </div>
      <div class="grid-item-dropdown">
        <Dropdown :title="$t(markets.title)" :options="markets.subHyperlinks" />
      </div>
      <div class="grid-item-dropdown">
        <Dropdown
          :title="$t(platforms.title)"
          :options="platforms.subHyperlinks"
        />
      </div>
      <div class="grid-item-dropdown">
        <Dropdown
          :title="$t(yourTrading.title)"
          :options="yourTrading.subHyperlinks"
        />
      </div>
      <!-- <div class="grid-item-dropdown">
        <Dropdown
          :title="$t(resources.title)"
          :options="resources.subHyperlinks"
        />
      </div> -->

      <div class="grid-item last-item">
        <NuxtLink
          :to="localPath('/contact-us')"
          class="title-item body-3-bold"
          style="display: block; text-decoration: none"
          >{{ $t(contanctUs.title) }}</NuxtLink
        >
        <ul class="social-media-group">
          <li
            class="social-media-circle"
            v-for="(item, index) in contanctUs.subHyperlinks"
            :key="index"
          >
            <a :href="item.path" target="_blank" rel="noopener noreferrer">
              <img
                :src="item.icon"
                width="24"
                height="24"
                :alt="item.alt"
              />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <div class="legal-part">
    <div class="grid-container-legal margin-general">
      <div class="grid-item">
        <a href="/documents/TermsandConditions.pdf" target="_blank" class="caption-1" rel="noopener noreferrer">
          {{ $t("footer.legalPagesTermsConditions") }}
        </a >
      </div>
      <img src="/images/ellipse.svg" alt="Elemento decorativo" />
      <div class="grid-item">
        <a href="/documents/PrivacyPolicy.pdf" target="_blank" class="caption-1" rel="noopener noreferrer">
          {{ $t("footer.legalPagesPrivacyPolicy") }}
        </a>
      </div>
      <img src="/images/ellipse.svg" alt="Elemento decorativo" />
      <div class="grid-item">
        <a href="/documents/AMLPolicy.pdf" target="_blank" class="caption-1" rel="noopener noreferrer">
          {{ $t("footer.legalPagesAMLPolicy") }}
        </a>
      </div>
      <img src="/images/ellipse.svg" alt="Elemento decorativo" />
      <div class="grid-item">
        <a href="/documents/RefundPolicy.pdf" target="_blank" class="caption-1" rel="noopener noreferrer">
          {{ $t("footer.legalPagesRefundPolicy") }}
        </a>
      </div>
      <img src="/images/ellipse.svg" alt="Elemento decorativo" />
      <div class="grid-item">
        <a href="/documents/ComplaintsprocedureEU.pdf" target="_blank" class="caption-1" rel="noopener noreferrer">
          {{ $t("footer.legalPagesComplaintsProcedure") }}
        </a>
      </div>
      <img src="/images/ellipse.svg" alt="Elemento decorativo" />
      <div class="grid-item">
        <a href="/documents/WithdrawalPolicy.pdf" target="_blank" class="caption-1" rel="noopener noreferrer">
          {{ $t("footer.legalPagesWithdrawalPolicy") }}
        </a>
      </div>
      <img src="/images/ellipse.svg" alt="Elemento decorativo" />
      <div class="grid-item">
        <a href="/documents/CookiePolicy.pdf" target="_blank" class="caption-1" rel="noopener noreferrer">
          {{ $t("footer.legalPagesCookiePolicy") }}
        </a>
      </div>
    </div>
  </div>

  <div class="legal-info">
    <div class="grid-container-info margin-general">
      <div class="cont-disclaimer">
        <p class="caption-2" >{{ $t("footer.text1") }}</p>
        <p class="caption-2" >{{ $t("footer.text2") }}</p>
        <p class="caption-2" >{{ $t("footer.text3") }}</p>
        <p class="caption-2" >{{ $t("footer.disclaimer", { percentage: lossPercentage }) }}</p>
        <!-- <p class="caption-2" v-html="formatContent('footer.headquarters', $t, localPath)"></p> -->
      </div>
      <div class="cont-disclaimer">
        <p class="caption-2" v-html="formatContent('footer.text5', $t, localPath)"></p>
        <p class="caption-2" v-html="formatContent('footer.text6', $t, localPath)"></p>
      </div>
      <div class="cont-disclaimer">
        <div class="sub-cont">
          <p class="caption-1-bold">{{ $t("footer.text13") }}</p>
          <p class="caption-2" v-html="formatContent('footer.text14', $t, localPath)"></p>
          <p class="caption-2" v-html="formatContent('footer.text15', $t, localPath)"></p>
        </div>
        <!-- <div class="sub-cont">
          <p class="caption-1-bold">{{ $t("footer.text16") }}</p>
          <p class="caption-2" v-html="formatContent('footer.text17', $t, localPath)"></p>
          <p class="caption-2" v-html="formatContent('footer.text18', $t, localPath)"></p>
        </div>
        <div class="sub-cont">
          <p class="caption-1-bold">{{ $t("footer.text7") }}</p>
          <p class="caption-2" v-html="formatContent('footer.text8', $t, localPath)"></p>
          <p class="caption-2" v-html="formatContent('footer.text9', $t, localPath)"></p>
        </div>
        <div class="sub-cont">
          <p class="caption-1-bold">{{ $t("footer.text10") }}</p>
          <p class="caption-2" v-html="formatContent('footer.text11', $t, localPath)"></p>
          <p class="caption-2" v-html="formatContent('footer.text12', $t, localPath)"></p>
        </div>
        <div class="sub-cont">
          <p class="caption-1-bold">{{ $t("footer.text19") }}</p>
          <p class="caption-2" v-html="formatContent('footer.text20', $t, localPath)"></p>
          <p class="caption-2" v-html="formatContent('footer.text21', $t, localPath)"></p>
        </div> -->
      </div>
    </div>
  </div>

  <!-- <div class="legal-info">
    <div class="grid-container-info margin-general">
      <div>
        <p class="caption-2">{{ $t("footer.copyright") }}</p>
        <p class="caption-2">{{ $t("footer.servicesDisclaimer") }}</p>
        <p class="caption-2">{{ $t("footer.servicesLegal") }}</p>
      </div>
      <div>
        <p v-if="regulations !== 'LATAM'" class="caption-2-bold">{{ $t("footer.cryptoNoticeTitle") }}</p>
        <p v-if="regulations !== 'LATAM'" class="caption-2">{{ $t("footer.cryptoNotice") }}</p>
        <p class="caption-2">{{ $t("footer.tradingRisk") }}</p>
      </div>
    </div>
  </div> -->
</template>
<script setup>
import { computed, ref } from "vue";
import { formatContent } from '~/utils/formatContent';

import Dropdown from "./../components/utils/dropdown/Dropdown.vue";
// import '~/assets/scss/components/footer.scss';

const { locale } = useI18n();
const { $regulationsVar } = useNuxtApp();

const lossPercentage = import.meta.env.VITE_CFD_LOSS_PERCENTAGE || 'error';

// Normaliza el locale (e.g. en-US -> en) y calcula la regulación reactivamente
const baseLocale = computed(() => (locale.value || '').toLowerCase().split('-')[0]);
const regulations = computed(() => $regulationsVar.getRegulation(baseLocale.value));
// Helper para seleccionar grupo por locale/regulación con prioridad ES > LATAM > default
function pickByLocale(map) {
  if (baseLocale.value === 'es' && map.ES) return map.ES;
  if (regulations.value === 'LATAM' && map.LATAM) return map.LATAM;
  return map.default;
}
const localPath = useLocalePath();
const markets = ref({
  title: "footer.marketsTitle",
  subHyperlinks: [
    { name: "footer.marketsForex", path: "/trading/markets/forex" },
    { name: "footer.marketsStocks", path: "/trading/markets/stocks" },
    /* { name: "footer.marketsFeatures", path: "/trading/markets/futures" }, */
    { name: "footer.marketscommodities", path: "/trading/markets/commodities" },
    { name: "footer.marketsindices", path: "/trading/markets/indices" },
  ],
});

const platforms = ref({
  title: "footer.resourcesTitle",
  subHyperlinks: [
    { name: "footer.resourcesAboutUs", path: "/company/about-us/" },
    /* { name: "footer.resourcescareers", path: "/company/careers/" }, */
    { name: "footer.resourcesAuthorized", path: "/company/regulation" },
    /* {
      name: "footer.resourcespressandmedia",
      path: "/company/press-and-media/",
    }, */
    /* {
      name: "footer.resourcesFormsDocuments",
      path: "/forms-and-documents",
    }, */
  ],
});

const yourTrading = ref({
  title: "footer.yourTradingTitle",
  subHyperlinks: [
    { name: "footer.yourTradingTradingConditions", path: "/trading/markets/trading-conditions/trading-conditions-events/" },
    { name: "footer.yourTradingEconomicCalendar", path: "/trading/markets/trading-conditions/forex-economic-calendar/" },
  ],
});

/* const resources = ref({
  title: "footer.servicesTitle",
  subHyperlinks: [
    { name: "footer.servicesMultimam", path: "/services/multimam" },
    {
      name: "footer.servicesCommuniTraders",
      path: "/services/communitraders",
    },
    {
      name: "footer.servicesVulkanBridge",
      path: "/services/vulkan-bridge",
    },
    {
      name: "footer.servicesTradeGATEHub",
      path: "/services/tradegatehub-surfs-up",
    },
  ],
}); */

const contactUsURLs = {
  /* ES: [
    { name: "footer.contactUsLinkedin", icon: "/images/linkedin.svg", alt: "Linkedin", path: "https://www.linkedin.com/company/tradeview-forex/mycompany/verification/" },
    { name: "footer.contactUsInstagram", icon: "/images/instagram.svg", alt: "Instagram", path: "https://www.instagram.com/radevieweurope" },
    { name: "footer.contactUsYouTube", icon: "/images/youtube.svg", alt: "Youtube", path: "https://www.youtube.com/c/TradeviewMarketsEspa%C3%B1ol" },
    { name: "footer.contactUsTikTok", icon: "/images/tiktok.svg", alt: "TikTok", path: "https://www.tiktok.com/@tradeviewmarketsesp?_t=8orug08PdoM&_r=1" },
    { name: "footer.contactUsFacebook", icon: "/images/facebook.svg", alt: "Facebook", path: "https://www.facebook.com/TradeviewES/about/" },
    { name: "footer.contactUsX", icon: "/images/x.svg", alt: "X", path: "https://x.com/TradeviewES" },
  ], */
  default: [
    { name: "footer.contactUsLinkedin", icon: "/images/linkedin.svg", alt: "Linkedin", path: "https://www.linkedin.com/company/tradevieweurope" },
    { name: "footer.contactUsInstagram", icon: "/images/instagram.svg", alt: "Instagram", path: "https://www.instagram.com/tradevieweurope" },
    { name: "footer.contactUsYouTube", icon: "/images/youtube.svg", alt: "Youtube", path: "https://www.youtube.com/@TradeviewEurope" },
    { name: "footer.contactUsTikTok", icon: "/images/tiktok.svg", alt: "TikTok", path: "https://www.tiktok.com/@tradevieweurope" },
    { name: "footer.contactUsFacebook", icon: "/images/facebook.svg", alt: "Facebook", path: "https://www.facebook.com/tradevieweurope" },
    { name: "footer.contactUsX", icon: "/images/x.svg", alt: "X", path: "https://x.com/Tradevieweurope" },
  ],
};

const contanctUs = computed(() => ({
  title: "footer.contactUsTitle",
  subHyperlinks: pickByLocale(contactUsURLs),
}));

const legalPagesURLs = {
  /* ES: [
    { name: "footer.legalPagesTermsConditions", path: "https://documents-tvmarkets.s3.us-west-1.amazonaws.com/07_T%C3%A9rminos+y+Condiciones+SP+LATAM.pdf" },
    { name: "footer.legalPagesPrivacyPolicy", path: "https://documents-tvmarkets.s3.us-west-1.amazonaws.com/SAC/EN/04_+Privacy+Policy+EN+LATAM.pdf" },
    { name: "footer.legalPagesAMLPolicy", path: "https://documents-tvmarkets.s3.us-west-1.amazonaws.com/08_+Politica+de+Prevencion+de+Lavado+de+Dinero+SP+LATAM.pdf" },
    { name: "footer.legalPagesWithdrawalPolicy", path: "https://documents-tvmarkets.s3.us-west-1.amazonaws.com/09_Pol%C3%ADticas+de+Retiro+SP+LATAM.pdf" },
    { name: "footer.legalPagesRefundPolicy", path: "https://documents-tvmarkets.s3.us-west-1.amazonaws.com/10_Politica+de+Reembolsos+SP+LATAM.pdf" },
    { name: "footer.legalPagesRiskDisclosure", path: "https://documents-tvmarkets.s3.us-west-1.amazonaws.com/03_+Divulgaci%C3%B3n+de+Riesgos+SP+LATAM.pdf" },
  ],
  LATAM: [
    { name: "footer.legalPagesTermsConditions", path: "https://documents-tvmarkets.s3.us-west-1.amazonaws.com/SAC/EN/07_Terms+and+Conditions+EN+LATAM.pdf" },
    { name: "footer.legalPagesPrivacyPolicy", path: "https://documents-tvmarkets.s3.us-west-1.amazonaws.com/SAC/EN/04_+Privacy+Policy+EN+LATAM.pdf" },
    { name: "footer.legalPagesAMLPolicy", path: "https://documents-tvmarkets.s3.us-west-1.amazonaws.com/08_AML+Policy+EN+LATAM.pdf" },
    { name: "footer.legalPagesWithdrawalPolicy", path: "https://documents-tvmarkets.s3.us-west-1.amazonaws.com/SAC/EN/09_Withdrawal+Policy+EN+LATAM.pdf" },
    { name: "footer.legalPagesRefundPolicy", path: "https://documents-tvmarkets.s3.us-west-1.amazonaws.com/SAC/EN/10_Refund+Policy+EN+LATAM.pdf" },
    { name: "footer.legalPagesRiskDisclosure", path: "https://documents-tvmarkets.s3.us-west-1.amazonaws.com/SAC/EN/03_+Risk+Disclosure+EN+LATAM.pdf" },
  ], */
  default: [
    { name: "footer.legalPagesTermsConditions", path: "https://documents-tvmarkets.s3.us-west-1.amazonaws.com/07_Terms+and+conditions.pdf" },
    { name: "footer.legalPagesPrivacyPolicy", path: "https://documents-tvmarkets.s3.us-west-1.amazonaws.com/04_+Privacy+Policy.pdf" },
    { name: "footer.legalPagesAMLPolicy", path: "https://documents-tvmarkets.s3.us-west-1.amazonaws.com/08_AML+Policy.pdf" },
    { name: "footer.legalPagesWithdrawalPolicy", path: "https://documents-tvmarkets.s3.us-west-1.amazonaws.com/09_Withdrawal+Policy.pdf" },
    { name: "footer.legalPagesRefundPolicy", path: "https://documents-tvmarkets.s3.us-west-1.amazonaws.com/10_Refund+Policy.pdf" },
    { name: "footer.legalPagesRiskDisclosure", path: "https://documents-tvmarkets.s3.us-west-1.amazonaws.com/03_+Risk+Disclosure.pdf" },
  ],
};

// Computed property: selección por locale/regulación (ES > LATAM > default)
const legalPages = computed(() => pickByLocale(legalPagesURLs));

function goTo(index) {
  window.open(legalPages.value[index].path, "_blank");
}

</script>
